import { useEffect, useState } from 'react';
import './Lists.scss';
import api from '../../js/api';
import Menu from '../../components/Menu/Menu';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import UserSelect from '../../components/UserSelect/UserSelect';
import { toast } from 'react-toastify';

export default function Lists() {

    const [lists, setLists] = useState([]);
    const [isOpenModal, setIsOpenModal] = useState(false);
    const [userSelectModal, setUserSelectModal] = useState(false);
    const [usersWithAccessModal, setUsersWithAccessModal] = useState(false);

    const [selectedList, setSelectedList] = useState(null);

    useEffect(() => {
        api.get('/user/lists?all=true').then((data) => {
            setLists(data);
        });
    }, [])

    return (
        <div id="lists">
            <div className='centered-container'>
                <h2>My Lists</h2>
                <br />
                <Button onClick={() => setIsOpenModal(true)}>
                    <span className='material-icon'>add</span> Add New List
                </Button>
                {
                    lists.length > 0 ? (
                        <div className='flex gap flex-column'>
                            {lists.map((list) => (
                                <div className='flex gap flex-align-center' key={list.id} >
                                    <Button
                                        key={list.id}
                                        class_="list-button flex-1"
                                        onClick={() => window.location.href = `/lists/${list.id}`}
                                    >
                                        <div className='list-title'>{list.title}</div>
                                        {list.description && <div className='list-description subtext'>{list.description}</div>}
                                    </Button>

                                    <Button key={`users-${list.id}`} onClick={() => {
                                        console.log(lists);
                                        console.log('Selected List ID:', list.id);
                                        setSelectedList(list);
                                        setUsersWithAccessModal(true);
                                    }}>
                                        <span className='material-icon'>groups</span>
                                    </Button>

                                    <Button key={`share-${list.id}`} class_={(list.role && list.role === 'owner') ? "" : "invisible"} onClick={() => {
                                        setSelectedList(list);
                                        setUserSelectModal(true);
                                    }}>
                                        <span className='material-icon'>share</span>
                                    </Button>

                                    <Button key={`delete-${list.id}`} class_="red white-text" onClick={async () => {
                                        if (!window.confirm(`Are you sure you want to delete the list "${list.title}"? This action cannot be undone.`)) {
                                            return;
                                        }

                                        const data = await api.delete(`/user/lists/${list.id}`);
                                        if (data.error) {
                                            console.error('Error deleting list:', data.error);
                                            toast.error('Failed to delete list. Please try again.');
                                            return;
                                        }
                                        toast.success('List deleted successfully!');
                                        const res = await api.get('/user/lists');
                                        setLists(res);
                                    }}>
                                        <span className='material-icon'>delete</span>
                                    </Button>
                                </div>

                            ))}
                        </div>
                    ) : (
                        <p>No lists available.</p>
                    )
                }
                {isOpenModal &&
                    <Modal
                        text="Add New List"
                        isOpen={true}
                        callback={() => setIsOpenModal(false)}
                    >
                        <div className='flex flex-column gap'>
                            <h2>New List</h2>
                            <br />
                            <input id="title" type="text" placeholder="List Title" className='input' />
                            <textarea id='description' placeholder="List Description (Optional)" className='input' />
                            <input id="type" type="text" placeholder="List Type (Optional)" className='input' />

                            <div className='flex gap flex-space-between'>
                                <Button text="Cancel" class_="red white-text" onClick={() => {
                                    setIsOpenModal(false);
                                }} />
                                <Button text="Add List" onClick={() => {
                                    const title = document.getElementById('title').value;
                                    const description = document.getElementById('description').value;
                                    let type = document.getElementById('type').value;

                                    // TODO: Check type in backend
                                    if (!type) {
                                        type = 'ratonera.net';
                                    }

                                    if (!window.confirm('Are you sure you want to add this list?')) {
                                        return;
                                    }

                                    api.post(`/user/lists`, {
                                        title: title,
                                        description: description,
                                        type: type,
                                    }).then(async (data) => {
                                        if (data.error) {
                                            console.error('Error adding list:', data.error);
                                            toast.error('Failed to add list. Please try again.');
                                            return;
                                        }
                                        toast.success('List created successfully!');
                                        const res = await api.get('/user/lists');
                                        console.log('Updated lists:', res);
                                        setLists(res);
                                        setIsOpenModal(false);
                                    }).catch((err) => {
                                        console.error('Error adding list:', err);
                                        toast.error('Failed to add list. Please try again.');
                                    });

                                }} />
                            </div>
                        </div>
                    </Modal>
                }
                {userSelectModal &&
                    <Modal
                        text="Select User to Share With"
                        isOpen={true}
                        callback={() => setUserSelectModal(false)}
                    >
                        <h3>Share With</h3>
                        <UserSelect onSelect={(user) => {
                            console.log('Selected user:', user);
                            console.log('List ID:', selectedList.id);
                            api.post(`/lists/${selectedList.id}/users/${user.login}`).then(() => {
                                toast.success(`List shared with ${user.login} successfully!`);
                                setUserSelectModal(false);
                                setSelectedList(null);
                            }).catch((err) => {
                                console.error('Error sharing list:', err);
                                toast.error('Failed to share list. Please try again.');
                            });
                        }} />
                    </Modal>
                }
                {usersWithAccessModal &&
                    <Modal
                        text="Users with Access"
                        isOpen={true}
                        callback={() => setUsersWithAccessModal(false)}
                    >
                        <h3>Users with Access</h3>
                        <div className='flex flex-column gap margin-top'>
                            {selectedList && selectedList.users && selectedList.users.length > 0 ? (
                                selectedList.users.map((user) => (
                                    <div key={user} className='flex gap flex-center'>
                                        <p key={user} className='flex-1'>
                                            {user.charAt(0).toUpperCase() + user.slice(1)}
                                        </p>
                                        <Button
                                            class_={selectedList.role && selectedList.role === 'owner' ? "red white-text" : "invisible"}
                                            onClick={async () => {
                                                if (!window.confirm(`Are you sure you want to remove access for ${user} from the list "${selectedList.title}"?`)) {
                                                    return;
                                                }
                                                try {
                                                    const res = await api.delete(`/lists/${selectedList.id}/users/${user}`, { silent: true });
                                                    if (res.error) {
                                                        console.error('Error removing user access:', res.error);
                                                        toast.error(res.error);
                                                        return;
                                                    }
                                                    toast.success(`Access removed for ${user} successfully!`);
                                                    // Update the selectedList state to remove the user
                                                    setSelectedList((prevList) => {
                                                        return {
                                                            ...prevList,
                                                            users: prevList.users.filter(u => u !== user)
                                                        };
                                                    });
                                                } catch (err) {
                                                    console.error('Error removing user access:', err);
                                                    toast.error('Failed to remove user access. Please try again.');
                                                }
                                            }}>
                                            <span className='material-icon'>remove_circle</span>
                                        </Button>
                                    </div>
                                ))
                            ) : (
                                <p>Only you have access to this list.</p>
                            )}
                        </div>
                    </Modal>
                }
            </div>
        </div>
    )
}